var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import styled, { css } from "styled-components";
import { colorBrandBase, formWhiteBackgroundColor, formLightBackgroundColor, formBoxShadow, boxShadowStandard } from "@nib-components/theme";
import { p } from "styled-components-spacing";
import { Box, Columns, Column, Stack } from "@nib/layout";
import Heading from "@nib-components/heading";
import { InfoSystemIcon } from "@nib/icons";
export var validBackgroundColorValues = ["light", "white"];
export var validTipLocationValues = ["left", "center", "right"];

var getTipAlignment = function getTipAlignment(alignment) {
  if (alignment === "right") {
    return "\n      margin-left: auto;\n      margin-right: 1rem;\n    ";
  } else if (alignment === "center") {
    return "\n      margin-left: auto;\n      margin-right: auto;\n    ";
  }

  return "margin-left: 2rem";
}; // eslint-disable-next-line @typescript-eslint/no-unused-vars


export var InfoBoxContainer = styled(function (_ref) {
  var withBorder = _ref.withBorder,
      borderColor = _ref.borderColor,
      backgroundColor = _ref.backgroundColor,
      withBoxShadow = _ref.withBoxShadow,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["withBorder", "borderColor", "backgroundColor", "withBoxShadow", "theme"]);

  return /*#__PURE__*/React.createElement(Box, rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  ", ";\n\n  // Additional .25rem for the absolutely positioned border below.\n  // We apply this even when no border is rendered because the text indentation should be consistent \n  // across InfoBoxes with and without the left border.\n  padding-left: 1.75rem;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), p(5), function (_ref2) {
  var withBorder = _ref2.withBorder,
      borderColor = _ref2.borderColor;
  return withBorder && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ::before {\n        content: '';\n        display: block;\n        width: 0.25rem;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        background-color: ", ";\n      }\n    "])), borderColor ? borderColor : colorBrandBase);
}, function (_ref3) {
  var withBoxShadow = _ref3.withBoxShadow;
  return withBoxShadow && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      box-shadow: ", ";\n    "])), boxShadowStandard || formBoxShadow);
}, function (_ref4) {
  var backgroundColor = _ref4.backgroundColor;
  return backgroundColor && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), backgroundColor === "light" ? css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            ", "\n          "])), formLightBackgroundColor) : css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            ", "\n          "])), formWhiteBackgroundColor));
}); // eslint-disable-next-line @typescript-eslint/no-unused-vars

export var InfoBoxTip = styled(function (_ref5) {
  var backgroundColor = _ref5.backgroundColor,
      tipLocation = _ref5.tipLocation,
      rest = _objectWithoutProperties(_ref5, ["backgroundColor", "tipLocation"]);

  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n  width: 24px;\n  height: 15px;\n  ", ";\n\n  &::after {\n    content: '';\n    display: block;\n    position: absolute;\n    bottom: 0;\n    border-left: 12px solid transparent;\n    border-right: 12px solid transparent;\n    border-top: 15px solid transparent;\n    border-bottom: 15px solid ", ";\n  }\n"])), function (_ref6) {
  var tipLocation = _ref6.tipLocation;
  return tipLocation && getTipAlignment(tipLocation);
}, function (props) {
  return props.backgroundColor && (props.backgroundColor === "light" ? formLightBackgroundColor : formWhiteBackgroundColor);
}); // eslint-disable-next-line @typescript-eslint/no-unused-vars

export var IconColumn = styled(function (_ref7) {
  var isSystemIcon = _ref7.isSystemIcon,
      rest = _objectWithoutProperties(_ref7, ["isSystemIcon"]);

  return /*#__PURE__*/React.createElement(Column, rest);
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  align-self: flex-start;\n  font-size: 0;\n  line-height: 1;\n\n  // If iconAndBorderColor is provided then this does nothing.\n  ", "\n"])), function (_ref8) {
  var isSystemIcon = _ref8.isSystemIcon;
  return isSystemIcon && css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), colorBrandBase);
}); // A box around the icon to ensure system icons occupy as much space as graphic ones

var FixedWidthBox = function FixedWidthBox(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    width: "2rem",
    display: "flex",
    justifyContent: "center"
  }, props));
};

var InfoBox = function InfoBox(props) {
  var _Icon$displayName;

  var children = props.children,
      title = props.title,
      titleComponent = props.titleComponent,
      withTip = props.withTip,
      tipLocation = props.tipLocation,
      backgroundColor = props.backgroundColor,
      withBorder = props.withBorder,
      iconAndBorderColor = props.iconAndBorderColor,
      withBoxShadow = props.withBoxShadow,
      withIcon = props.withIcon,
      Icon = props.icon,
      otherProps = _objectWithoutProperties(props, ["children", "title", "titleComponent", "withTip", "tipLocation", "backgroundColor", "withBorder", "iconAndBorderColor", "withBoxShadow", "withIcon", "icon"]);

  var isSystemIcon = Icon && ((_Icon$displayName = Icon.displayName) === null || _Icon$displayName === void 0 ? void 0 : _Icon$displayName.includes("System"));
  return /*#__PURE__*/React.createElement("div", null, withTip && /*#__PURE__*/React.createElement(InfoBoxTip, {
    tipLocation: tipLocation,
    backgroundColor: backgroundColor
  }), /*#__PURE__*/React.createElement(InfoBoxContainer, _extends({
    backgroundColor: backgroundColor,
    withBorder: withBorder,
    borderColor: iconAndBorderColor,
    withBoxShadow: withBoxShadow,
    borderRadius: "standard"
  }, otherProps), /*#__PURE__*/React.createElement(Columns, {
    verticalAlign: "center",
    space: 5
  }, withIcon && /*#__PURE__*/React.createElement(IconColumn, {
    width: "content",
    isSystemIcon: isSystemIcon
  }, Icon && /*#__PURE__*/React.createElement(FixedWidthBox, null, /*#__PURE__*/React.createElement(Icon, {
    size: isSystemIcon ? "sm" : "md",
    fill: iconAndBorderColor
  }))), /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Stack, {
    space: 2
  }, title && /*#__PURE__*/React.createElement(Heading, {
    size: 4,
    component: titleComponent
  }, title), /*#__PURE__*/React.createElement("div", null, children))))));
};

InfoBox.displayName = "InfoBox";
InfoBox.defaultProps = {
  titleComponent: "h3",
  withIcon: true,
  icon: InfoSystemIcon,
  backgroundColor: "white",
  withBorder: true,
  withBoxShadow: true,
  withTip: false,
  tipLocation: "left"
};
export default InfoBox;